import { Divider, Typography, Box } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import OpeningDayDto from "../../models/OpeningDayDto";
import OpeningHour from "./OpeningHours";

interface OpeningDayProps {
    openingDay: OpeningDayDto;
}

export default function OpeningDay({ openingDay }: OpeningDayProps) {
    return (
        <>
            <Grid2 xs={16} key={openingDay.id} style={{ justifyContent: 'center', textAlign: 'center', paddingBottom: '0' }}>
                {
                    openingDay.order !== 0 &&
                    <>
                        <Divider sx={{ mr: '33%', ml: '33%', bgcolor: 'white' }} />
                        <Divider sx={{ mr: '35%', ml: '35%', bgcolor: 'white' }} />
                    </>
                }
                <Typography fontSize='1.2rem' style={{ fontWeight: 'bold' }}>
                    {openingDay.value}
                </Typography>
            </Grid2>
            <Box key={-openingDay.id} display="flex" justifyContent="center" alignItems="center" width='100%'>
                <Box display="flex" justifyContent="center" alignItems="center" width='100%'>
                    <Grid2 xs={16} key={openingDay.id + "+" + openingDay.id}>
                        <Grid2 container direction="row" columns={12} spacing={0} key={openingDay.id + '-' + openingDay.id} style={{ padding: '0' }}>
                            {
                                openingDay.openingHours.map((hour) => {
                                    return (<OpeningHour key={hour.id} openingHour={hour} />);
                                })
                            }
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </>
    );

}